export enum ShipmentAssignedFleetsType {
  All = 'ALL',
  WithoutSpecific = 'WITHOUT_SPECIFIC',
  Specific = 'SPECIFIC'
}
